module.exports = __webpack_public_path__ + "img/RW.85f6ca97.svg";